<template>
  <div>
    <el-navbar />
    <main class="container mt-5">
      <div class="bg-white py-4"></div>
      <div class="mt-5">
        <div v-if="step == 0">
          <div class="d-flex justify-content-center">
            <div class="mb-4">
              <div class="row g-2 mb-3 align-items-center">
                <div class="col-12">
                  <h2 class="text-center mb-4 text-primary">
                    Welches Gerät willst du reparieren?
                  </h2>
                  <input
                    type="search"
                    id="search"
                    class="form-control"
                    placeholder="Suche dein Gerät"
                    title="Gebe den Namen Ihres Geräts ein"
                    v-model="search"
                    aria-label="Suche"
                    aria-describedby="basic-addon1"
                  />
                </div>
              </div>
              <div
                class="row row-cols-1 row-cols-md-4 row-cols-lg-5 g-5 d-flex justify-content-center"
                ref="devices"
              >
                <div
                  class="col"
                  v-for="(device, index) in listDevices"
                  :key="index"
                >
                  <router-link
                    :to="{
                      name: 'Reparaturwerkstatt',
                      params: { uid: device.uid },
                    }"
                    custom
                    v-slot="{ navigate }"
                  >
                    <div
                      class="card h-100 border-0"
                      role="link"
                      @click="navigate"
                      @keypress.enter="navigate"
                    >
                      <img
                        v-if="device.thumbnail"
                        class="card-img-top"
                        :src="$store.state.config.endpoint + device.thumbnail"
                        :alt="device.thumbnail"
                      />
                      <div
                        class="card-body py-0"
                        v-if="$store.state.updatingPostsObject"
                      >
                        <p class="card-text mb-0" title="Marke">
                          <small class="text-primary"
                            ><i
                              class="fa-solid fa-sm fa-mobile-screen-button"
                            ></i>
                            {{ device.marker }}</small
                          >
                        </p>
                        <h5 class="card-title" title="Gerätename">
                          {{ device.name }}
                        </h5>
                        <p class="card-muted small" title="Serie">
                          Serie: {{ device.series }}
                        </p>
                      </div>
                      <div class="card-body" v-else>
                        <h5 class="card-title placeholder-glow">
                          <span class="placeholder col-6"></span>
                        </h5>
                        <p class="card-text placeholder-glow">
                          <span class="placeholder col-7"></span>
                          <span class="placeholder col-4"></span>
                          <span class="placeholder col-4"></span>
                          <span class="placeholder col-6"></span>
                          <span class="placeholder col-8"></span>
                        </p>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="border-bottom mb-4" v-if="step >= 1">
          <h2 class="mb-5 display-5">Reparatur für dein Smartphone</h2>
          <div v-if="step === 1">
            <h4 class="mb-2 text-primary fw-bold">
              Alle Service- & Reparaturarbeiten für das Gerät:
            </h4>
            <div class="list-group mb-3" v-if="services">
              <label
                type="link"
                :for="'flexCheckServices-' + item.serviceId"
                v-for="(item, index) in services"
                :key="index"
                class="list-group-item list-group-item-action"
                aria-current="true"
              >
                <div class="d-flex w-100 justify-content-between text-primary">
                  <div class="mb-1">
                    <input
                      :id="'flexCheckServices-' + item.serviceId"
                      class="form-check-input mt-2"
                      type="checkbox"
                      aria-label="Checkbox for following text input"
                      @click="selectService(item)"
                      required
                    />
                    <span class="h4 ms-2">{{ item.title }}</span>
                    <span class="ms-4 ps-1 text-muted small d-block"
                      >Reparatur typ: {{ item.name }}</span
                    >
                  </div>
                  <div class="fw-bold">
                    <span class="d-block">{{ item.price }}€</span>
                    <img
                      v-if="item.thumbnail"
                      :src="$store.state.config.endpoint + item.thumbnail"
                      :alt="item.thumbnail"
                      class="img-fluid me-2"
                      width="30px"
                    />
                  </div>
                </div>
                <p class="my-1">
                  <span class="small">{{ item.description }}</span>
                </p>
              </label>
            </div>
            <table class="table mb-3" v-else>
              <tbody>
                <tr v-for="(item, index) in 5" :key="index">
                  <th scope="row">
                    <p class="placeholder-glow">
                      <span class="placeholder col-12"></span>
                    </p>
                  </th>
                  <td>
                    <p class="placeholder-glow">
                      <span class="placeholder col-12"></span>
                    </p>
                  </td>
                  <td>
                    <p class="placeholder-glow">
                      <span class="placeholder col-12"></span>
                    </p>
                  </td>
                  <td>
                    <p class="placeholder-glow">
                      <span class="placeholder col-12"></span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <button
              class="btn btn-outline-secondary me-2 mb-2"
              @click="backToStart"
            >
              Zurück
            </button>
            <button
              v-if="servicesIsSelectedx.length > 0"
              class="btn btn-primary mb-2"
              @click="getProceed"
            >
              Weiter
            </button>
            <button
              v-else
              disabled
              class="btn btn-outline-primary mb-2"
            >
              Weiter
            </button>
          </div>
          <div v-else>
            <h5 class="mb-2">Die ausgewählten Reparaturarten</h5>
            <ul class="list-group col-12 col-md-8 mb-2">
              <li
                class="list-group-item d-flex align-items-center"
                v-for="(item, index) in servicesIsSelectedx"
                :key="index"
              >
                <img
                  v-if="item.thumbnail"
                  :src="$store.state.config.endpoint + item.thumbnail"
                  :alt="item.thumbnail"
                  class="img-fluid me-3"
                  width="40px"
                />
                <h5 class="p-1">{{ item.title }}</h5>
                <span class="ms-auto badge bg-primary rounded-pill"
                  >{{ item.price }}€</span
                >
              </li>
            </ul>
            <div class="col-12 col-md-8 mb-2">
              <div class="row row-cols-2 mb-3 d-flex justify-content-between">
                <div class="col-6">
                  <button class="btn btn-outline-secondary" @click="step = 1">
                    Zurück zu Reparatur
                  </button>
                </div>
                <div class="col-6 text-muted text-end">
                  Summe: {{ data.sum }}€ <span>zzgl. MwSt.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="border-bottom mb-4" v-if="step >= 2">
          <div v-if="step === 2">
            <h2 class="mb-2 text-primary fw-bold">Gemma weiter!</h2>
            <div class="list-group mb-3" v-if="proceed">
              <label
                type="link"
                :for="'flexCheckProceed-' + item.uid"
                v-for="(item, index) in proceed"
                :key="index"
                class="list-group-item list-group-item-action"
                aria-current="true"
              >
                <div class="d-flex w-100 justify-content-between text-primary">
                  <div class="mb-1">
                    <input
                      class="form-check-input mt-2"
                      type="radio"
                      :id="'flexCheckProceed-' + item.uid"
                      :value="item.uid"
                      v-model="proceedIsSelected"
                      aria-label="radio für proceed"
                      @click="selectProceed(item)"
                      required
                    />
                    <span class="h4 ms-2">{{ item.title }}</span>
                  </div>
                </div>
                <p class="my-1">
                  <span class="small">{{ item.description }}</span>
                </p>
              </label>
            </div>
            <table class="table mb-3" v-else>
              <tbody>
                <tr v-for="(item, index) in 5" :key="index">
                  <th scope="row">
                    <p class="placeholder-glow">
                      <span class="placeholder col-12"></span>
                    </p>
                  </th>
                  <td>
                    <p class="placeholder-glow">
                      <span class="placeholder col-12"></span>
                    </p>
                  </td>
                  <td>
                    <p class="placeholder-glow">
                      <span class="placeholder col-12"></span>
                    </p>
                  </td>
                  <td>
                    <p class="placeholder-glow">
                      <span class="placeholder col-12"></span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <button
              v-if="proceedIsSelectedx"
              class="btn btn-primary mb-2"
              @click="step = 3"
            >
              Weiter
            </button>
            <button
              v-else
              disabled
              class="btn btn-outline-primary mb-2"
            >
              Weiter
            </button>
          </div>
          <div v-else>
            <h5 class="mb-2">Die ausgewählten Abwicklung</h5>
            <div class="list-group col-12 col-md-8 mb-1">
              <h5 class="fw-light p-1">{{ proceedIsSelectedx.title }}</h5>
            </div>
            <div class="col-12 col-md-8 mb-3">
              <button class="btn btn-outline-secondary" @click="step = 2">
                Abwicklung ändern
              </button>
            </div>
          </div>
        </div>
        <div class="border-bottom mb-4" v-if="step >= 3">
          <form v-if="step === 3">
            <h2 class="mb-3 text-primary fw-bold">Deine persönlichen Daten</h2>
            <div class="row">
              <div class="col-12 col-md-2 mb-3">
                <label for="gender" class="form-label">Anrede</label>
                <select
                  class="form-select"
                  id="gender"
                  v-model="data.gender"
                  aria-label="Default select example"
                >
                  <option value="he" selected>Herr</option>
                  <option value="she">Frau</option>
                  <option value="company">Firma</option>
                </select>
              </div>
              <div class="col-12 col-md-5 mb-3">
                <label for="firstname" class="form-label">Vorname</label>
                <input
                  type="text"
                  maxlength="50"
                  class="form-control"
                  id="firstname"
                  v-model="data.firstname"
                  aria-describedby="emailHelp"
                  required
                />
              </div>
              <div class="col-12 col-md-5 mb-3">
                <label for="lastname" class="form-label"
                  >Familien-/Nachname</label
                >
                <input
                  type="text"
                  maxlength="50"
                  class="form-control"
                  id="lastname"
                  v-model="data.lastname"
                  aria-describedby="emailHelp"
                  required
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 mb-3">
                <label for="phonenumber" class="form-label">Telefon</label>
                <input
                  type="tel"
                  maxlength="11"
                  class="form-control"
                  id="phonenumber"
                  v-model="data.phonenumber"
                  aria-describedby="emailHelp"
                />
              </div>
              <div class="col-12 col-md-6 mb-3">
                <label for="email" class="form-label">E-Mail-Adresse</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  v-model="data.email"
                  aria-describedby="emailHelp"
                  required
                />
                <div id="emailHelp" class="form-text">
                  Wir werden deine E-Mail-Adresse niemals an Dritte weitergeben.
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 mb-3">
                <label for="street" class="form-label">Straße/Nr.</label>
                <input
                  type="text"
                  maxlength="50"
                  class="form-control"
                  id="street"
                  v-model="data.street"
                  aria-describedby="emailHelp"
                  required
                />
              </div>
              <div class="col-12 col-md-6 mb-3">
                <label for="housenumber" class="form-label">Stiege/Tür</label>
                <input
                  type="text"
                  maxlength="50"
                  class="form-control"
                  id="housenumber"
                  v-model="data.housenumber"
                  aria-describedby="emailHelp"
                  required
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 mb-3">
                <label for="zipcode" class="form-label">PLZ</label>
                <input
                  type="text"
                  maxlength="50"
                  class="form-control"
                  id="zipcode"
                  v-model="data.zipcode"
                  aria-describedby="emailHelp"
                  required
                />
              </div>
              <div class="col-12 col-md-6 mb-3">
                <label for="city" class="form-label">Bundesland</label>
                <input
                  type="text"
                  maxlength="50"
                  class="form-control"
                  id="city"
                  v-model="data.city"
                  aria-describedby="emailHelp"
                  required
                />
              </div>
            </div>
            <hr />
            <h2 class="mb-3 text-primary fw-bold">Gerätedaten</h2>
            <div class="row">
              <div class="col-12 col-md-6 mb-3">
                <!--TODO: add pass-->
                <label for="password" class="form-label">Tastensperre</label>
                <input
                  type="text"
                  maxlength="50"
                  class="form-control"
                  id="password"
                  v-model="data.password"
                  aria-describedby="emailHelp"
                />
              </div>
              <div class="col-12 col-md-6 mb-3">
                <label for="simlock" class="form-label">SIM-Lock</label>
                <input
                  type="text"
                  maxlength="50"
                  class="form-control"
                  id="simlock"
                  v-model="data.simlock"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-6 mb-3">
                <label for="imei" class="form-label">IMEI Nummer</label>
                <input
                  type="text"
                  maxlength="50"
                  class="form-control"
                  id="imei"
                  v-model="data.imei"
                  aria-describedby="emailHelp"
                />
              </div>
              <div class="col-12 col-md-6 mb-3">
                <label for="color" class="form-label">Farbe</label>
                <input
                  type="text"
                  maxlength="50"
                  class="form-control"
                  id="color"
                  v-model="data.color"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-12 mb-3">
              <label for="description" class="form-label">Anmerkungen</label>
              <textarea
                class="form-control"
                maxlength="255"
                id="description"
                v-model="data.description"
                rows="3"
              ></textarea>
            </div>
            <div class="col mb-3 form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="agree"
                v-model="data.agree"
              />
              <label class="form-check-label" for="agree"
                >Ich bin mit dem
                <router-link
                  :to="{ name: 'CookiesPolicy' }"
                  custom
                  v-slot="{ navigate }"
                >
                  <a
                    role="link"
                    class="btn-link"
                    title="Zur Datenschutz seite"
                    aria-current="page"
                    @click="navigate"
                    @keypress.enter="navigate"
                  >
                    Datenschutz
                    <i class="fa-solid fa-sm fa-up-right-from-square"></i>
                  </a>
                </router-link>
                von Mobile Tech Zone einverstanden und bestätige die Richtigkeit
                meiner Angaben. Ich bin mit der Verarbeitung meiner Daten zum
                Zwecke der Reparaturarbeiten -Verwaltung einverstanden.
              </label>
            </div>
            <button @click="exportTableToExcel"
              title="Alle Daten als Excel Datei herunterladen"
              class="btn btn-outline-success mb-3 me-2"
              >
              <span class="me-1">Daten herunterladen</span>
              <i class="fa-solid fa-sm fa-download"></i>
            </button>
            <button
              type="submit"
              class="btn btn-primary mb-3"
              @click="createOrder"
            >
              Absenden
            </button>
          </form>
          <div v-else>
            {{ data }}
            <button class="btn btn-secondary" @click="step = 3">Zurück</button>
          </div>
        </div>
        <table v-if="step ==3" id="tblData" class="table d-none">
          <tr>
            <th>Vorgehen titel</th>
            <th>Anrede</th>
            <th>Vorname</th>
            <th>Nachname</th>
            <th>E-Mail-Adresse</th>
            <th>Telefon</th>
            <th>Straße/Nr.</th>
            <th>Stiege/Tür</th>
            <th>PLZ</th>
            <th>Bundesland</th>
            <th>Tastensperre</th>
            <th>SIM-Lock</th>
            <th>IMEI Nummer</th>
            <th>Farbe</th>
            <th>Anmerkungen</th>
          </tr>
          <tr>
            <td>{{ proceedIsSelectedx.title }}</td>
            <td>{{ data.gender }}</td>
            <td>{{ data.firstname }}</td>
            <td>{{ data.lastname }}</td>
            <td>{{ data.email }}</td>
            <td>{{ data.phonenumber }}</td>
            <td>{{ data.street }}</td>
            <td>{{ data.housenumber }}</td>
            <td>{{ data.zipcode }}</td>
            <td>{{ data.city }}</td>
            <td>{{ data.password }}</td>
            <td>{{ data.simlock }}</td>
            <td>{{ data.imei }}</td>
            <td>{{ data.color }}</td>
            <td>{{ data.description }}</td>
          </tr>
          <tr>
            <td class="fw-bold">Die ausgewählten Reparaturarten</td>
          </tr>
          <tr v-for="(item, index) in servicesIsSelectedx" :key="index">
            <td>Reparaturarten</td>
            <td>{{ item.title }}</td>
            <td>Preis</td>
            <td>{{ item.price }} Euro</td>
            <td>Summe</td>
            <td>{{ data.sum }} Euro</td>
          </tr>
        </table>
      </div>
    </main>
    <el-footer />
  </div>
</template>

<script>
import elNavbar from "../../components/Navbar.vue";
import elFooter from "../../components/Footer.vue";

export default {
  name: "Reparaturwerkstatt",
  metaInfo: {
    title: "Reparaturwerkstatt",
    titleTemplate: "%s | Mobile Tech Zone",
  },

  components: { elNavbar, elFooter },

  data() {
    return {
      competated: false,
      step: 0,
      servicesIsSelected: [],
      servicesIsSelectedx: [],
      proceed: undefined,
      services: undefined,
      search: "",
      listDevices: undefined,
      proceedIsSelected: undefined,
      proceedIsSelectedx: undefined,
      data: {
        // Customers
        firstname: "",
        lastname: "",
        phonenumber: "",
        email: "",
        street: "",
        housenumber: "",
        zipcode: "",
        city: "",
        gender: "he",
        // Customers Device
        password: "",
        simlock: "",
        imei: "",
        color: "",
        description: "",
        sum: 0,
        agree: false,
      },
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.load();
    });
  },

  watch: {
    "$route.name"() {
      this.load();
    },
    "$route.params.uid"() {
      document.location.reload()
      this.load();
    },

    search(val) {
      if (val.length <= 0) {
        this.listDevices = [];
        return;
      }
      this.listDevices = [];
      this.$store.state.updatingPostsObject.map((element) => {
        if (
          element.marker.toUpperCase().indexOf(val.toUpperCase()) > -1 ||
          element.series.toUpperCase().indexOf(val.toUpperCase()) > -1 ||
          element.name.toUpperCase().indexOf(val.toUpperCase()) > -1
        ) {
          this.listDevices.push(element);
        }
      });
    },
  },

  methods: {
    // check fields
    checkform() {
      if (this.data.lastname.length > 2 &&
          this.data.firstname.length > 2 &&
          this.data.phonenumber.length > 2 &&
          this.data.email.length > 2 &&
          this.data.street.length > 2 &&
          this.data.housenumber.length > 1 &&
          this.data.zipcode.length > 2 &&
          this.data.city.length > 2) {
            this.competated = true;
      }
    },
    load() {
      if (this.$route.params.uid) {
        this.getServicesOfDevice();
      } else {
        this.getDevices();
      }
    },

    backToStart() {
      this.step = 0;
      this.getDevices();
      this.$router.push({
        name: "Repair",
      });
    },

    getServicesOfDevice() {
      this.$store.state.modules.api
        .getServicesOfDevice(this.$route.params.uid)
        .then((resp) => {
          console.log(resp);
          if (resp.status == 200) {
            this.step = 1;
            this.services = resp.data.units;
          } else {
            if (this.$route.name != "Repair") {
              this.backToStart();
            }

            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                title: "Fehlermeldung",
                message: "Ops! Das Gerät hat keine Reparaturen!",
              },
              2500
            );
          }
          this.$store.state.utils.loaded = true;
        })
        .catch((err) => {
          this.$store.state.utils.loaded = true;
        });
    },

    selectService(e) {
      const index = this.servicesIsSelected.indexOf(e.serviceId);

      if (index >= 0) {
        this.servicesIsSelected.splice(index, 1);
        this.servicesIsSelectedx.splice(index, 1);
        this.data.sum -= Number(e.price);
      } else {
        this.servicesIsSelected.push(e.serviceId);
        this.servicesIsSelectedx.push(e);
        this.data.sum += Number(e.price);
      }
    },

    getProceed() {
      this.$store.state.utils.loaded = false;

      this.$store.state.modules.api
        .getProceed()
        .then((resp) => {
          if (resp.status == 200) {
            console.log(resp.data);
            this.proceed = resp.data.units;
            this.step = 2;
          }
          this.$store.state.utils.loaded = true;
        })
        .catch((err) => {
          this.$store.state.utils.loaded = true;
        });
    },

    selectProceed(e) {
      this.proceedIsSelected = e.uid;
      this.proceedIsSelectedx = e;
    },

    exportTableToExcel() {
      var downloadLink;
      var dataType = "application/vnd.ms-excel";
      var tableSelect = document.getElementById("tblData");
      var tableHTML = tableSelect.outerHTML.replace(/ /g, "%20");
      // Specify file name
      let filename = "Bestelldaten-mobile-tech-zone.xls";
      // Create download link element
      downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      if (navigator.msSaveOrOpenBlob) {
        var blob = new Blob(["\ufeff", tableHTML], {
          type: dataType,
        });
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = "data:" + dataType + ", " + tableHTML;
        // Setting the file name
        downloadLink.download = filename;
        //triggering the function
        downloadLink.click();
      }
    },

    createOrder() {
      event.preventDefault();
      this.checkform();
      if (this.data.agree && this.competated) {
        console.log("resp");
        this.data.device_key = this.$route.params.uid;
        this.$store.state.modules.api
          .createOrder(
            this.servicesIsSelected,
            this.proceedIsSelected,
            this.data
          )
          .then((resp) => {
            console.log(resp);
            if (resp.status == 200) {
              this.$router.push({ name: "LandingPage" });
            }
            this.$store.state.utils.loaded = true;
          })
          .catch((err) => {
            this.$store.state.utils.loaded = true;
          });
          this.$store.state.utils.setNewNotifications(
            {
              type: "success",
              title: "Neue Bestellung!",
              message: "Deine Bestellung wurde erfolgreich gesendet. Sehe dir deine E-Mail an!",
            },
            4000
          );
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            title: "Fehlermeldung",
            message: "Bitte fülle die leeren Felder aus!",
          },
          2500
        );
      }
    },

    getDevices() {
      this.$store.state.updatingPostsObject = [];
      this.$store.state.modules.api
        .getDevices()
        .then((resp) => {
          if (resp.status == 200) {
            console.log(resp.data);
            this.$store.state.updatingPostsObject = resp.data.units;
          }
          this.$store.state.utils.loaded = true;
        })
        .catch((err) => {
          this.$store.state.utils.loaded = true;
        });
    },
  },
};
</script>

<style scoped></style>
